<div>
  <!-- SVG Clip Path Definition -->
  <svg viewBox="0 0 100 100" preserveAspectRatio="none">
    <clipPath id="curveRightClip" clipPathUnits="objectBoundingBox">
      <!-- From top-left to top-right with a curve inward on the right -->
      <path d="M0,0 L1,0 Q0.85,0.5 1,1 L0,1 Z" />
    </clipPath>
  </svg>

  <div class="authGridContainer authGridContainer--login authGridContainer--fullScreen">
    <a class="authGrid__logo" href="/" aria-label="Link to main page" tabindex="0">
      <img src="./assets/sbk1-logo.svg" alt="SBK1 - Monitoring" />
    </a>

    <div class="authGridColumn authGridColumn--callToActionParent image-half mario">
      <div class="createFreeAccount">
        <span class="createFreeAccount__text" style="font-size: 1.6em; line-height: 30px; display: none"
          >Effektives HACCP Maangement</span
        >
      </div>
    </div>

    <div class="authGridColumn authGridColumn--formParent">
      <div class="formContainer loginForm">
        <div class="example-small-box">
          <h1 class="mb-0" style="font-size: 25px">SBK1 - Monitoring</h1>
          <h3 class="mb-3">Neuen Aktivierungslink anfordern</h3>
          
          <div *ngIf="!success">
            <p class="mb-4">Ihr Aktivierungslink ist abgelaufen. Geben Sie Ihre E-Mail-Adresse ein, um einen neuen Link zu erhalten.</p>
            
            <form (ngSubmit)="requestNewToken()" [formGroup]="form" class="mb-3">
              <!-- Email -->
              <div class="form-group">
                <label class="form-label" for="email"> E-Mail </label>
                <input
                  type="email"
                  formControlName="email"
                  id="email"
                  class="form-control"
                  [class.is-invalid]="form.controls['email'].invalid && form.controls['email'].touched"
                  required
                  placeholder="name@address.com" />
                <div *ngIf="form.controls['email'].invalid && form.controls['email'].touched" class="invalid-feedback">
                  Bitte geben Sie eine gültige E-Mail-Adresse ein
                </div>
              </div>
              
              <!-- Submit -->
              <div class="flex items-center justify-between">
                <button 
                  mat-button 
                  mat-ripple 
                  class="btn-primary" 
                  type="submit"
                  [disabled]="form.invalid || isLoading">
                  <span *ngIf="!isLoading">Aktivierungslink anfordern</span>
                  <span *ngIf="isLoading">Wird gesendet...</span>
                </button>
              </div>
            </form>
          </div>

          <div *ngIf="success" style="text-align: center; padding: 20px;">
            <p style="color: green; font-weight: bold; margin-bottom: 10px;">✓ E-Mail wurde erfolgreich gesendet!</p>
            <p class="mb-3">Bitte überprüfen Sie Ihr E-Mail-Postfach und klicken Sie auf den Aktivierungslink.</p>
            <button mat-button mat-ripple class="btn-primary" (click)="goToLogin()">
              Zur Anmeldung
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


